import { Common } from "../models/common";

const initialState: Common = {
  isMenuOpen: false,
  isSynced: false,
  currentRouteName: "HomeScreen"
};

export default function(state = initialState, action) {
  switch (action.type) {
    case "TOGGLE_MENU_OPEN":
      return {
        ...state,
        isMenuOpen: !state.isMenuOpen
      };
    case "SET_CURRENT_ROUTE_NAME":
      return {
        ...state,
        currentRouteName: action.currentRouteName
      };
    case "DID_SYNC":
      return {
        ...state,
        isSynced: true
      };
    default:
      return state;
  }
}
